export default "__VITE_ASSET__3ea3bd27__"